import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "3239f0c6-9b19-45bb-b46d-32a26d9f4d4a",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    orientation: "vertical",
    type: "number",
    prefixText: "Input numerical answer",
    unit: "A",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 0.75,
};
